import { Compass } from "lucide-react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", to = "/" }) => {
  const dims = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to={to} className="flex items-center gap-2.5 group" data-testid="brand-logo">
      <div className={`${dims} relative rounded-xl bg-gradient-to-br from-cyan-400 to-indigo-500 flex items-center justify-center glow-cyan transition-transform group-hover:scale-105`}>
        <Compass className="h-1/2 w-1/2 text-[#041016]" strokeWidth={2.5} />
      </div>
      <div className="leading-none">
        <span className={`${text} font-display font-extrabold text-white`}>EntranceZone</span>
        <span className={`${text} font-display font-extrabold text-cyan-400`}> AI</span>
      </div>
    </Link>
  );
};
